/**
 * @generated SignedSource<<f420327a1cc9b0d218420b7260a28255>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type productSidePanelContent_RemoveAreaBgMutation$variables = {
  productIds: ReadonlyArray<number>;
  ruleId: string;
};
export type productSidePanelContent_RemoveAreaBgMutation$data = {
  readonly removeProductsFromAreaBackgroundRule: {
    readonly result: boolean;
  };
};
export type productSidePanelContent_RemoveAreaBgMutation = {
  response: productSidePanelContent_RemoveAreaBgMutation$data;
  variables: productSidePanelContent_RemoveAreaBgMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "productIds"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ruleId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "productIds",
        "variableName": "productIds"
      },
      {
        "kind": "Variable",
        "name": "ruleId",
        "variableName": "ruleId"
      }
    ],
    "concreteType": "ProductAssignmentResult",
    "kind": "LinkedField",
    "name": "removeProductsFromAreaBackgroundRule",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "productSidePanelContent_RemoveAreaBgMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "productSidePanelContent_RemoveAreaBgMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "f2eeba3746a26d34139e2b043d980260",
    "id": null,
    "metadata": {},
    "name": "productSidePanelContent_RemoveAreaBgMutation",
    "operationKind": "mutation",
    "text": "mutation productSidePanelContent_RemoveAreaBgMutation(\n  $ruleId: ID!\n  $productIds: [Long!]!\n) {\n  removeProductsFromAreaBackgroundRule(ruleId: $ruleId, productIds: $productIds) {\n    result\n  }\n}\n"
  }
};
})();

(node as any).hash = "f3912d8c0c355f9d88db6ff3bf6870be";

export default node;
